import { Identity } from "../auth";
import { UserId, ScreenName } from "../core";
import { UserRef } from "./types.generated";

export function identityToUserRef<R>(identity: Identity<R>): UserRef {
  return {
    userId: identity.userId,
    screenName: identity.screenName,
  };
}

export function userRef(screenName?: ScreenName, userId?: UserId): UserRef {
  return {
    userId: userId ?? null,
    screenName: screenName ?? null,
  };
}
